module.exports = __webpack_public_path__ + "img/icon_2_9.9c924f78.png";